import { Heading } from "@radix-ui/themes";
import useSignInAnonymously from "../hooks/useSignInAnonymously";
import { Loader } from "@/components";
import i18next from "i18next";

export const SignUpAnonymouslyUrl = (): JSX.Element => {
  const { status, loading, error } = useSignInAnonymously();

  if (loading) {
    return (
      <Loader>
        <Heading>{i18next.t("auth.methods.anonymous.login.loading")}</Heading>
      </Loader>
    );
  }

  if (error) {
    return <>{error.message}</>;
  }

  return (
    <Loader>
      <Heading>{i18next.t("auth.methods.anonymous.login.loading")}</Heading>
    </Loader>
  );
};
